import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Legacy /participantmanager/add URL — open the add modal on the list page.
 */
const AddParticipant = () => (
  <Navigate
    to="/participantmanager/active"
    replace
    state={{ openAddParticipant: true }}
  />
);

export default AddParticipant;
